import axios from '@/axios'

const notice = {
  // 获取公告
  async getNoticeList(params) {
    return await axios.post('/uc/user/notice/list', params, { des: '直客wap获取公告', sTime: new Date().getTime() })
  },
  // 获取公告详情 根据消息编号
  async getNoticeDetail(params) {
    return await axios.post('/uc/user/notice/detail', params, { des: '直客wap获取公告详情 根据消息编号', sTime: new Date().getTime() })
  },
  //查询答题状况
  async getQuestion(params = {}) {
    return await axios.post('/uc/ucUpgrade/getAccountUpgrade', params, { des: '直客wap查询答题状况', sTime: new Date().getTime() })
  },
  async getBannerList(params) {
    return await axios.post('/api/services/app/Banner/Banners', params, { des: '获取首页banner', sTime: new Date().getTime() })
  },
}

export default notice


// WEBPACK FOOTER //
// ./src/api/notice.js